import { IVisitorProvider } from 'core/model/interfaces/visitor.interface';

export class VisitorGeneric {
  private readonly provider: IVisitorProvider;
  private static instance: VisitorGeneric | null = null;
  private installed = false;

  constructor(provider: IVisitorProvider) {
    this.provider = provider;
  }

  static getInstance(provider: IVisitorProvider): VisitorGeneric {
    this.instance ??= new VisitorGeneric(provider);

    return this.instance;
  }

  install() {
    if (this.installed) {
      return;
    }
    this.installed = true;
  }

  getInformation() {
    return this.provider.getInformation();
  }
}
